import { render, staticRenderFns } from "./section-item.vue?vue&type=template&id=3d6f76f4&"
import script from "./section-item.vue?vue&type=script&lang=js&"
export * from "./section-item.vue?vue&type=script&lang=js&"
import style0 from "./section-item.vue?vue&type=style&index=0&id=3d6f76f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports